import { LocaleValue } from "@eres/core/dist/LocaleValue";

export interface ValidationError {
	errorNumber: number;
	errorMessage?: string;
	MessageAr?: string;
	MessageEn?: string;
	ErrorMessageAr?: string;
	ErrorMessageEn?: string;
	identity: number;
}

export interface ValuationCompany {
	id: number;
	name: LocaleValue;
	phone: string;
	mobile?: string;
	email: string;
	address: string;
	fax?: string;
	licenseNumber: string;
	realEstateNumber: number;
	licenseIssueDate: string;
	licenseExpiryDate: string;
	rank?: number;
	rankName?: string;
	classificationValue: number;
	awardsCount: number;
	logoUrl?: string;
}

export interface ValuationRequest {
	requestId: number;
	requestNumber: string;
	requestStatusNameAr: string;
	requestStatusNameEn: string;
	requestStatusId: number;
}

export interface ValuationRequestDetails {
	community: string;
	municipalityNumber: string;
	areaSizeSqMtReq: string;
	valuationScope: string;
	valuationReason: string;
	valuationCompany: string;
	notesReq: string;
}

export interface ValuationDetails {
	valuer: string;
	valuerCardNumber: string;
	areaSizeSqMt: string;
	areaSizeSqFt: string;
	buildUpAreaSqMt: string;
	buildUpAreaSqFt: string;
	worthSqMt: string;
	worthSqFt: string;
	totalPropertyWorth: string;
	dateOfValuation: string;
	notes: string;
	documentURL?: string;
	rejectionReason?: string;
}

export interface ExValLookupData {
	id?: number;
	name?: LocaleValue;
	parentId?: any;
}

export enum ExValLookUp {
	REASONS = "EvaluationReason",
	PROPERTY_TYPES = "PropertyTypes",
	REQUEST_SOURCE = "RequestSource",
}

export const ExValLookUpKeys = {
	[ ExValLookUp.REASONS ]: "Reasons",
	[ ExValLookUp.PROPERTY_TYPES ]: "PropertyTypes",
	[ ExValLookUp.REQUEST_SOURCE ]: "RequestSource",
};

export const LookUpKeys = [ ExValLookUp.REASONS, ExValLookUp.PROPERTY_TYPES, ExValLookUp.REQUEST_SOURCE ];

export interface PostExValData {
	evaluationCompany: ExValCompany,
	evaluationReason: ExValLookupData,
	requestNotes: String,
	propertyTypeId: number | undefined,
	property: ExValProperty
}

export interface ExValProperty {
	propertyTypeId: number,
	tabuPropertyId: number,
}

export interface ExValCompany {
	id: number,
	name: LocaleValue
}

export enum ValuationRequestStatusID {
	NEW = 1,
	ASSIGNED,
	COMPLETED,
	REJECTED,
	ISSUED
}

export function getExternalValuationStatusClass( item: ValuationRequest ) {
	switch ( item.requestStatusId ) {
		case ValuationRequestStatusID.NEW:
			return "pending";

		case ValuationRequestStatusID.REJECTED:
			return "rejected";

		case ValuationRequestStatusID.ASSIGNED:
			return "picked";

		case ValuationRequestStatusID.COMPLETED:
			return "completed";

		case ValuationRequestStatusID.ISSUED:
			return "paid";
	}
}
